module.exports = __webpack_public_path__ + "public/images/slider/speaker-6.c47748a50e87a1d0fc62e6677ef9d750.jpeg";